<div class = "main">
    <div class = "formcont">
        <div class = "formtitle">
            Upload scedule
        </div>
        <form [formGroup]="upsched" class = "form" >
            <input type = "text" placeholder="Enter scedule Name" class = "input" formControlName = "sceduleName">
            <mat-form-field>
                <mat-label style="font-size: 80%; color: black;">Select Type</mat-label>
                <mat-select [(value)]="type"
                    style="text-align: center; font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;">
                    <mat-option value="{{x.name}}" *ngFor = "let x of typeoptions">
                        {{x.displayname}}</mat-option>
                </mat-select>
            </mat-form-field>
            Upload scedule: (Optional)
            <input type="file" id="file" (change)="receiptUpload($event.target.files)" class="input">
            <div class = "submitbut" (click) = "submitsch()">
                Submit
            </div>
        </form>
    </div>
</div>